import { BUCKET_DESTINATION } from '../config'
import { PerformanceBucketThresholds, PerformancePuzzleThresholds } from '../types'

const BUCKETS = [1, 2, 3, 4, 5, 10, 15, 20, 25] as const

function getPerformanceBucket(
	thresholds: PerformanceBucketThresholds,
	time: number
): string | null {
	for (const bucket of BUCKETS) {
		if (time <= thresholds[bucket]) return `Top ${bucket}%`
	}
	return null
}

async function loadThresholdsForPuzzle(puzzleNumber: number): Promise<PerformancePuzzleThresholds> {
	const source = `https://${BUCKET_DESTINATION}global-performance/daily5/${puzzleNumber}.json`
	const response = await fetch(source)
	if (!response.ok) {
		throw new Error(`Failed to fetch global performance thresholds (${response.status})`)
	}

	return response.json() as Promise<PerformancePuzzleThresholds>
}

async function getGlobalPerformance(puzzleNumber: number, time: number): Promise<string | null> {
	try {
		const performance = await loadThresholdsForPuzzle(puzzleNumber)
		return getPerformanceBucket(performance.thresholds, time)
	} catch (error) {
		console.error(error)
		return null
	}
}

export default getGlobalPerformance
